import styles from '../styles/ShopList.module.scss'
import { target } from '../../../utils'
import { FiveStar } from '../shared'
import { ShopSlider } from '../../search'
import { defaultShopPicture } from '../../../config'
import get from 'lodash/get'
import ShopTags from './ShopTags'
import { FormattedMessage } from 'react-intl'
import CardButtons from './CardButtons'

import PropTypes from 'prop-types'

export default function DcCard({
  shop,
  isElearningView,
  highlightPinOnMap,
  removeHighlight,
  trackGtmEvent,
  trackListingClick,
}) {
  const image = get(shop, 'background.800x800') || defaultShopPicture
  const { languages, activities } = shop
  return (
    <a
      href={isElearningView ? shop.padiUrl : shop.url}
      className={styles.container}
      target={target}
      onMouseEnter={highlightPinOnMap}
      onMouseLeave={removeHighlight}
      onClick={trackGtmEvent}
    >
      <FiveStar membershipLevel={shop.membershipLevel} />
      <p className={styles.title}>{shop.title}</p>
      <p className={styles.address}>{shop.shortAddress}</p>
      <div className={styles.pictureContainer}>
        <ShopSlider
          apiUrl={`/api/adventure/v1/dive-centers/${shop.id}/images/`}
          background={image}
          replacePhotos
          shopUrl={shop.url}
        />
      </div>
      <ShopTags tags={shop.tags} />
      <div className={styles.detailsRow}>
        <div className={styles.details}>
          <p className={styles.detailsTitle}>
            <FormattedMessage id='languages' defaultMessage='Languages' />
          </p>
          <p className={styles.detailsInfo}>
            {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
            {languages.length ? languages.join(', ') : '–'}
          </p>
        </div>
        <div className={styles.details}>
          <p className={styles.detailsTitle}>
            <FormattedMessage id='hours' defaultMessage='Hours' />
          </p>
          {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
          <p className={styles.detailsInfo}>{shop.openHour || '–'}</p>
        </div>
        <div className={styles.details}>
          <p className={styles.detailsTitle}>
            <FormattedMessage
              id='courses_activites'
              defaultMessage='Courses/Activities'
            />
          </p>
          <p className={styles.detailsInfo}>
            {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
            {activities.length ? activities.join(', ') : '–'}
          </p>
        </div>
      </div>
      <CardButtons
        shop={shop}
        isElearningView={isElearningView}
        trackListingClick={trackListingClick}
      />
    </a>
  )
}

DcCard.propTypes = {
  shop: PropTypes.object.isRequired,
  isElearningView: PropTypes.bool.isRequired,
  highlightPinOnMap: PropTypes.func.isRequired,
  removeHighlight: PropTypes.func.isRequired,
  trackGtmEvent: PropTypes.func.isRequired,
  trackListingClick: PropTypes.func.isRequired,
}
